/** Keep viewport size and input capabilities separate; wide screens can use touch. */
export const mediaQueries = {
  compactViewport: '(max-width: 768px)',
  noHover: '(hover: none)',
  coarsePointer: '(pointer: coarse)',
  darkColorScheme: '(prefers-color-scheme: dark)',
} as const;
